import CryptoJS from "crypto-js";
export const transactionType = {
  CREDIT: "CREDIT",
  DEBIT: "DEBIT",
  MANUAL_CREDIT: "MANUAL CREDIT",
  MANUAL_DEBIT: "MANUAL DEBIT",
  AUTO_REVERSAL: "AUTO REVERSAL",
  MANUAL_REVERSAL: "MANUAL REVERSAL",
  ADD_CREDIT_LIMIT: "ADD CREDIT LIMIT",
  REDUCE_CREDIT_LIMIT: "REDUCE CREDIT LIMIT",
  ADD_LIEN: "ADD LIEN",
  REDUCE_LIEN: "REDUCE LIEN",
};
export const ADMIN = "admin";
export const ISSUPERADMIN = "superAdmin";
export const MOBILE = "MOBILE";
export const TXNID = " TRANSACTION ID";
export const REQID = "REQUEST ID";
export const ODRCODE = "ORDER CODE";
export const UTR = "UTR";
export const VPA = "VPA";
export const AMOUNT = "AMOUNT";

export const LEOPAY_TITLE_NAME = "Merchant Portal";

export const checkTxnIsnotFake = (value, data, checkfor) => {
  if (
    checkfor === REQID &&
    data?.id !== value &&
    data?.orderCode !== value &&
    data?.utr !== value
  ) {
    return value;
  } else if (
    checkfor === TXNID &&
    data?.requestId !== value &&
    data?.orderCode !== value &&
    data?.utr !== value
  ) {
    return value;
  } else if (
    checkfor === ODRCODE &&
    data?.requestId !== value &&
    data?.id !== value &&
    data?.utr !== value
  ) {
    return value;
  } else if (
    checkfor === UTR &&
    data?.requestId !== value &&
    data?.id !== value &&
    data?.orderCode !== value
  ) {
    return value;
  } else {
    return "";
  }
};

export const setpageContent = (currentPage, finalLength, totalPost) => {
  console.log("currentPage", currentPage, finalLength, totalPost);
  const firstIndex = currentPage == 0 ? 1 : currentPage * 20;
  const finalIndex = currentPage == 0 ? 20 : firstIndex + finalLength;
  console.log(
    "totalPost",
    firstIndex,
    finalIndex,
    totalPost,
    totalPost < finalIndex,
    `Showing ${firstIndex} to ${totalPost}`
  );
  if (totalPost < finalIndex) {
    return `Showing ${firstIndex} to ${totalPost}`;
  }
  return `Showing ${firstIndex} to ${finalIndex} of  ${totalPost}`;
};

export const Statusoptions = [
  { value: "SUCCESS_AUTO", label: "SUCCESS_AUTO" },
  { value: "SUCCESS_MANUAL", label: "SUCCESS_MANUAL" },
  { value: "SUCCESS_INCOMPLETE", label: "SUCCESS_INCOMPLETE" },
  { value: "SUCCESS_FROM_FAILED", label: "SUCCESS_FROM_FAILED" },
  { value: "ACCEPTED", label: "ACCEPTED" },
  { value: "PENDING_PAYMENT", label: "PENDING_PAYMENT" },
  { value: "TIMEOUT", label: "TIMEOUT" },
  { value: "PAYMENT_PROCESSED", label: "PAYMENT_PROCESSED" },
  { value: "CANCELED", label: "CANCELED" },
  { value: "FAILED", label: "FAILED" },
  { value: "REVERSED", label: "REVERSED" },
  { value: "SYS_ERROR", label: "SYS_ERROR" },
  { value: "UNPROCESSED", label: "UNPROCESSED" },
];

export const TicketStatusoptions = [
  { value: "NEW", label: "NEW" },
  { value: "IN_PROGRESS", label: "IN_PROGRESS" },
  { value: "RESOLVED", label: "RESOLVED" },
  { value: "DECLINED_DUE_TO_TIMEOUT", label: "DECLINED_DUE_TO_TIMEOUT" },
  { value: "DECLINED_DUE_TO_FRAUD", label: "DECLINED_DUE_TO_FRAUD" },
  { value: "NOT_RECEIVED", label: "NOT_RECEIVED" },
  { value: "ASSIGNED", label: "ASSIGNED" },
  { value: "NEED_FURTHER_PROOF", label: "NEED_FURTHER_PROOF" },
  { value: "REFUNDED", label: "REFUNDED" },
  { value: "NOT_OUR_VPA", label: "NOT_OUR_VPA" },
];

export const searchbyOptions = [TXNID, REQID, AMOUNT, ODRCODE, UTR, VPA];
export const searchbyOptionspayout = [TXNID, REQID, AMOUNT, UTR];

export const searchbyOptionsForTicket = [REQID, UTR];

export const statusIntialData = [
  {
    id: "SUCCESS",
    count: 0,
    total: 0,
  },
  {
    id: "PENDING",
    count: 0,
    total: 0,
  },
  {
    id: "FAILED",
    count: 0,
    total: 0,
  },
];
export const ONEMONTH = "ONEMONTH";
export const TWOMONTH = "TWOMONTH";
export const THREEMONTH = "THREEMONTH";
export const tooltipStyle = {
  fontSize: "12px",
  height: "30px",
  lineHeight: "30px",
  padding: "0 10px",
};

/**
 * A small container for parsed results.
 */
class DecodedResult {
  constructor(oldPass, newPass, shaSaltTime) {
    this.oldPass = oldPass; // Original old password
    this.newPass = newPass; // Original new password
    this.shaSaltTime = shaSaltTime; // The SHA of base64(salt + ddMMyyHHmm)
  }
}
export const createdOnDate = (date) => {
  return date.split(".")[0].replace("T", " ");
};
/**
 * Helper to get current date/time in "ddMMyyHHmm" format.
 */
function getDDMMYYHHmm() {
  const now = new Date();
  const dd = String(now.getDate()).padStart(2, "0");
  const MM = String(now.getMonth() + 1).padStart(2, "0");
  const yy = String(now.getFullYear() % 100).padStart(2, "0");
  const HH = String(now.getHours()).padStart(2, "0");
  const mm = String(now.getMinutes()).padStart(2, "0");
  return dd + MM + yy + HH + mm;
}

/**
 * Convert a string to Base64.
 */
function toBase64(str) {
  return btoa(unescape(encodeURIComponent(str)));
}

/**
 * Decode Base64.
 */
function fromBase64(b64) {
  return decodeURIComponent(escape(atob(b64)));
}

/**
 * Compute SHA-256 (hex) of a string.
 */
function sha256Hex(str) {
  return CryptoJS.SHA256(str).toString(CryptoJS.enc.Hex);
}

/**
 * Interleave 5 strings with dots.
 */
function interleave5WithDot(s1, s2, s3, s4, s5) {
  const arr = [s1, s2, s3, s4, s5];
  const active = [true, true, true, true, true];
  let exhaustedCount = 0;
  const NUM_STRINGS = 5;

  let i = 0;
  let result = "";

  while (exhaustedCount < NUM_STRINGS) {
    let appendedChar = false;
    for (let j = 0; j < NUM_STRINGS; j++) {
      if (!active[j]) continue;
      if (i < arr[j].length) {
        result += arr[j].charAt(i);
        appendedChar = true;
      } else {
        result += ".";
        active[j] = false;
        exhaustedCount++;
      }
    }
    if (appendedChar) i++;
    else break;
  }
  return result;
}

/**
 * Deinterleave a string.
 */
function deinterleave5WithDot(interleaved) {
  const NUM_STRINGS = 5;
  const sbs = [[], [], [], [], []];
  const active = [true, true, true, true, true];
  let exhaustedCount = 0;

  let index = 0;
  const length = interleaved.length;

  while (exhaustedCount < NUM_STRINGS && index < length) {
    for (let j = 0; j < NUM_STRINGS; j++) {
      if (!active[j]) continue;
      if (index >= length) break;
      const c = interleaved.charAt(index++);
      if (c === ".") {
        active[j] = false;
        exhaustedCount++;
      } else {
        sbs[j].push(c);
      }
    }
  }

  return sbs.map((chars) => chars.join(""));
}

/**
 * Build final interleaved string from oldPass, newPass, salt.
 */
function buildInterleavedString(oldPass, newPass, salt) {
  const nowStr = getDDMMYYHHmm();
  const saltTime = salt + nowStr;

  // Base64
  const base64Old = toBase64(oldPass);
  const base64New = toBase64(newPass);
  const base64SaltT = toBase64(saltTime);

  // SHA-256
  const shaOld = sha256Hex(base64Old);
  const shaNew = sha256Hex(base64New);
  const shaSaltT = sha256Hex(base64SaltT);

  // Interleave
  return interleave5WithDot(
    base64Old,
    shaOld,
    base64New,
    shaNew,
    shaSaltT
  ).replace(/\.+$/, "");
}

/**
 * Parse the interleaved string.
 */
function parseInterleavedString(interleaved) {
  const [base64Old, shaOld, base64New, shaNew, shaSaltTime] =
    deinterleave5WithDot(interleaved);

  if (sha256Hex(base64Old) !== shaOld) {
    throw new Error("SHA verification failed for oldPass!");
  }
  if (sha256Hex(base64New) !== shaNew) {
    throw new Error("SHA verification failed for newPass!");
  }

  const oldPass = fromBase64(base64Old);
  const newPass = fromBase64(base64New);

  return new DecodedResult(oldPass, newPass, shaSaltTime);
}

export { buildInterleavedString, parseInterleavedString };
export const checkActive = (data) => {
  let disabled = false;
  if (data.assigned && data.activeSim && data.enabled && data.forUse) {
    disabled = true;
  }
  return disabled;
};
export const PAYIN = "PAYIN";
export const PAYOUT = "PAYOUT";

export function isSuccess(data) {
  return data?.status?.startsWith("SUCCESS") || false;
}
export const serviceId = "upi-web-config";

// export function applyReversed(firstArray, reverseArray) {
//   // Deep clone the input array to avoid mutating the original
//   if (Array.isArray(reverseArray) && reverseArray.length == 0)
//     return firstArray;
//   const updatedArray = JSON.parse(JSON.stringify(firstArray));

//   const totalReversedAmount = reverseArray.reduce(
//     (sum, item) => sum + parseInt(item.amount),
//     0
//   );
//   const totalReversedCount = reverseArray.reduce(
//     (sum, item) => sum + item.count,
//     0
//   );

//   console.log("🟡 Total reversed amount to add:", totalReversedAmount);
//   console.log("🟡 Total reversed count to add:", totalReversedCount);

//   const successEntry = updatedArray.find((item) => item.id === "SUCCESS");

//   if (successEntry) {
//     console.log("🟢 Before SUCCESS →", successEntry);
//     successEntry.amount += totalReversedAmount;
//     successEntry.count += totalReversedCount;
//     console.log("🟢 After SUCCESS  →", successEntry);
//   } else {
//     console.warn("❌ No 'SUCCESS' entry found in array.");
//   }

//   console.log("\n✅ Final Updated Total Array (original untouched):");
//   console.log(JSON.stringify(updatedArray, null, 2));

//   return updatedArray;
// }

export function applyReversedToSuccess(firstArray, secondArray) {
  const successEntry = firstArray.find((item) => item.id === "SUCCESS");

  // Sum all REVERSED entries
  const totalReversed = secondArray
    .filter((item) => item.id === "REVERSED")
    .reduce(
      (acc, curr) => {
        acc.amount += parseFloat(curr.amount);
        acc.count += parseInt(curr.count);
        return acc;
      },
      { amount: 0, count: 0 }
    );

  if (successEntry) {
    successEntry.amount =
      parseFloat(successEntry.amount) + totalReversed.amount;
    successEntry.count += totalReversed.count;
  }

  return firstArray;
}

export const checkFailed = (status) => {
  if (
    status === "FAILED" ||
    status === "SYS_ERROR" ||
    status === "CANCELED" ||
    status === "UNPROCESSED" ||
    status === "REVERSED"
  ) {
    return true;
  }

  return false;
};

export function applyReversed(firstArray, reverseArray) {
  // Deep clone the input array to avoid mutating the original
  if (Array.isArray(reverseArray) && reverseArray.length == 0)
    return firstArray;
  const updatedArray = JSON.parse(JSON.stringify(firstArray));

  const totalReversedAmount = reverseArray.reduce(
    (sum, item) => sum + parseInt(item.amount),
    0
  );
  const totalReversedCount = reverseArray.reduce(
    (sum, item) => sum + item.count,
    0
  );

  console.log("🟡 Total reversed amount to add:", totalReversedAmount);
  console.log("🟡 Total reversed count to add:", totalReversedCount);

  const successEntry = updatedArray.find((item) => item.id === "SUCCESS");

  if (successEntry) {
    console.log("🟢 Before SUCCESS →", successEntry);
    successEntry.amount += totalReversedAmount;
    successEntry.count += totalReversedCount;
    console.log("🟢 After SUCCESS  →", successEntry);
  } else {
    console.warn("❌ No 'SUCCESS' entry found in array.");
  }

  console.log("\n✅ Final Updated Total Array (original untouched):");
  console.log(JSON.stringify(updatedArray, null, 2));

  return updatedArray;
}
export const SUCCESS_STATUSES = new Set([
  "SUCCESS_AUTO",
  "SUCCESS_MANUAL",

  "SUCCESS_FROM_FAILED",
]);

export const PENDING_STATUSES = new Set([
  "PENDING_PAYMENT",
  "PAYMENT_PROCESSED",
  "ACCEPTED",
  "PENDING",
  "TIMEOUT",
  "SUCCESS_INCOMPLETE",
]);

export const FAILED_STATUSES = new Set([
  "FAILED",
  "REVERSED",
  "CANCELED",
  "SYS_ERROR",
  "UNPROCESSED",
]);
export const getTxnStatusType = (status) => {
  if (SUCCESS_STATUSES.has(status)) return "success";
  if (PENDING_STATUSES.has(status)) return "pending";
  if (FAILED_STATUSES.has(status)) return "failed";

  return "failed"; // fallback safety
};

export const isActualSuccessStatus = (statusId) => {
  if (!statusId) return false;

  return statusId.startsWith("SUCCESS") && statusId !== "SUCCESS_INCOMPLETE";
};
export const isValidPayoutItem = (item) => {
  const status = item?.id?.status || item?.id;
  if (!status) return false;

  if (isActualSuccessStatus(status)) {
    return item.count > 0;
  }

  return (
    status === "ACCEPTED" ||
    status === "REVERSED" ||
    status === "PENDING_PAYMENT" ||
    status === "PENDING" ||
    status === "TIMEOUT" ||
    status === "PAYMENT_PROCESSED" ||
    status === "SUCCESS_INCOMPLETE"
  );
};
